/**
 * 打包块管理
 */
 import axios from '../request';
 export default{
    

    /**
     * 打包块管理
     */
    // 查询打包块列表信息
    searchDistList: params =>
        axios.post(`/materials/chainPack/findList?pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params),
    // 添加或修改打包块信息
    insertDistOrUpdate: params =>
        axios.post('/materials/chainPack/save', params),
    // 打包块信息详情
    detailsDistDevice: params =>
        axios.post('/materials/chainPack/detail', params),
    // 删除打包块信息
    deleteDistDevice: params =>
        axios.post('/materials/chainPack/delete', params),
    //打包块管理下拉
    getAllTrayDevice: params =>
        axios.get('/materials/', {params}),
    //导出数据
    exportTrayDatas:params=>
        axios({
            method: 'get',
            url: '/',
            responseType: 'blob',
            params: params
        }),


 }